import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
const __default__ = {
  data() {
    return {
      barData: [],
      barChartRaceData: [],
      allBarChartRaceData: [],
      pieChartData: [],
      currentObj: {},
      current: "",
      currentDate: "",
      updatedAt: "",
      activeGrade: "all",
      schools: [],
      allSchools: [],
      allSchoolsTable: [],
      totalStudents: 0,
      totalAbsence: 0,
      totalInfection: 0,
      monthList: [],
      barMonth: "current",
      selectedDay: moment().format("YYYY-MM-DD"),
      // 当日の日付
      intervalId: undefined
    };
  },
  head: {
    title: {
      inner: "ダッシュボード"
    },
    meta: []
  },
  watch: {
    isAuthenticated: {
      async handler(v) {
        if (v) {
          // this.barMonth = "current";
          const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=all`), getData(`attendance_summary?bar=1&to=${this.selectedDay}`), getData(`attendance_summary?barChartRace=1&date=${this.selectedDay}`)]);
          const absenceBySchool = data[0].items;
          this.pieChartData = data[1].items;
          this.barData = data[2].items;
          this.barChartRaceData = this.allBarChartRaceData = this.optimizeBarChartRace(data[3].items);
          this.schools = this.allSchools = this.mergeSchoolAbsence(absenceBySchool);
          this.getTotal();
        }
      },
      immediate: true
    }
  },
  created() {
    moment.locale("ja");
    this.currentObj = moment(); // 当日の日付
    this.current = this.currentObj.format("YYYY年MM月DD日 HH時mm分");
    this.currentDate = this.currentObj.format("YYYY年MM月DD日");
    this.updatedAt = this.currentObj.format("HH時mm分");
    this.createMonthList();
  },
  mounted() {
    this.intervalId = setInterval(async () => {
      if (this.$auth.isAuthenticated) {
        const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=${this.activeGrade}`), this.barMonth === "current" ? getData(`attendance_summary?bar=1&to=${this.selectedDay}`) : getData(`attendance_summary?bar=1&${this.barMonth}`), getData(`attendance_summary?barChartRace=1&date=${this.selectedDay}`)]);
        const absenceBySchool = data[0].items;
        this.pieChartData = data[1].items;
        this.barData = data[2].items;
        this.allBarChartRaceData = this.optimizeBarChartRace(data[3].items);
        this.allSchools = this.mergeSchoolAbsence(absenceBySchool);
        if (this.activeGrade === "all") {
          this.schools = this.allSchools.map(v => v);
          this.barChartRaceData = this.allBarChartRaceData;
        } else {
          this.schools = this.allSchools.filter(v => v.type === this.activeGrade);
          this.barChartRaceData = this.allBarChartRaceData.filter(v => v.type === this.activeGrade);
        }
        this.getTotal();
        this.currentObj = moment(); // 当日の日付
        this.current = this.currentObj.format("YYYY年MM月DD日 HH時mm分");
        this.currentDate = this.currentObj.format("YYYY年MM月DD日");
        this.updatedAt = this.currentObj.format("HH時mm分");
      }
      // 10分の時は600000
    }, 600000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    async setActiveGrade(grade) {
      this.activeGrade = grade;
      if (this.$auth.isAuthenticated) {
        const data = await getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=${this.activeGrade}`);
        this.pieChartData = data.items;
        if (this.activeGrade === "all") {
          this.schools = this.allSchools;
          this.barChartRaceData = this.allBarChartRaceData;
        } else {
          this.schools = this.allSchools.filter(v => v.type === this.activeGrade);
          this.barChartRaceData = this.allBarChartRaceData.filter(v => v.type === this.activeGrade);
        }
        this.getTotal();
      }
    },
    getTotal() {
      this.totalAbsence = 0;
      this.totalInfection = 0;
      const verticalTotal = this.schools.filter(v => v.student_count !== 0).reduce((sum, v) => {
        sum["student_count"] += v.student_count;
        Object.keys(v["absence"]).forEach(key => {
          if (key !== "date" && key !== "school_id") {
            if (key in sum["absence"]) {
              sum["absence"][key] += v["absence"][key];
            } else {
              sum["absence"][key] = v["absence"][key];
            }
          }
        });
        this.totalAbsence += v.pointsMap.absencePointsMap;
        this.totalInfection += v.pointsMap.infection;
        return sum;
      }, {
        id: 0,
        name: "全校",
        student_count: 0,
        absence: {}
      });
      this.totalStudents = verticalTotal.student_count;
      this.allSchoolsTable = [verticalTotal, ...this.schools];
    },
    createMonthList() {
      const currentStartDay = this.currentObj.clone().startOf("month");
      this.monthList = [{
        month: this.currentObj.month() + 1,
        period: `from=${currentStartDay.format("YYYY-MM-DD")}&to=${this.currentObj.format("YYYY-MM-DD")}`
      }];
      for (const d = currentStartDay.subtract(1, "month"); d.month() !== 2; d.subtract(1, "month")) {
        this.monthList.push({
          month: d.month() + 1,
          period: `from=${d.format("YYYY-MM-DD")}&to=${d.clone().endOf("month").format("YYYY-MM-DD")}`
        });
      }
    },
    // カレンダーの日付が変更されたとき
    async changeDate() {
      // console.log(this.selectedDay);
      if (this.$auth.isAuthenticated) {
        const data = await Promise.all([getData(`attendance_summary?dashboard=1&date=${this.selectedDay}`), getData(`attendance_summary?pieChart=1&date=${this.selectedDay}&school_type=${this.activeGrade}`), getData(`attendance_summary?bar=1&to=${this.selectedDay}`), getData(`attendance_summary?barChartRace=1&date=${this.selectedDay}`)]);
        const absenceBySchool = data[0].items;
        this.pieChartData = data[1].items;
        this.barData = data[2].items;
        this.allBarChartRaceData = this.optimizeBarChartRace(data[3].items);
        this.allSchools = this.mergeSchoolAbsence(absenceBySchool);
        if (this.activeGrade === "all") {
          this.schools = this.allSchools.slice();
          this.barChartRaceData = this.allBarChartRaceData;
        } else {
          this.schools = this.allSchools.filter(v => v.type === this.activeGrade);
          this.barChartRaceData = this.allBarChartRaceData.filter(v => v.type === this.activeGrade);
        }
        this.getTotal();
      }
    },
    // barグラフの期間変更を行ったとき
    async barMonthChange() {
      if (this.$auth.isAuthenticated) {
        if (this.barMonth === "current") {
          const data = await getData(`attendance_summary?bar=1&to=${this.selectedDay}`);
          this.barData = data.items;
        } else {
          const data = await getData(`attendance_summary?bar=1&${this.barMonth}`);
          this.barData = data.items;
        }
      }
    }
  }
};
import { inject } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import TableRow from "@/components/dashboard/TableRow";
import PieChart from "@/components/charts/PieChart";
import Bar from "@/components/charts/Bar";
import PointsMap from "@/components/charts/PointsMap";
import BarChartRace from "@/components/charts/BarChartRace";
import Inc137 from "@/components/common/Inc137";

import { isAuthenticatedKey, meKey, allSchoolListKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'Dashboard',
  setup(__props, {
    expose
  }) {
    const isAuthenticated = inject(isAuthenticatedKey);
    const me = inject(meKey);
    const allSchoolList = inject(allSchoolListKey);

    // apiから取得したBarChartRaceのデータを変形する
    const optimizeBarChartRace = itemList => {
      return itemList.map(v => {
        const school = allSchoolList.value.find(w => w.id === v.school_id);
        return {
          ...v,
          name: school.short_name ?? school.name,
          type: school.type
        };
      });
    };

    // 表と地図用のデータ作成
    const mergeSchoolAbsence = absenceBySchool => {
      return allSchoolList.value.map(v => {
        const school = structuredClone(v);
        const absence = absenceBySchool.find(w => w.school_id === school.id);
        if (absence) {
          school["absence"] = absence;
          school["pointsMap"] = {
            absencePointsMap: absence.absencePointsMap,
            infection: Object.keys(absence).reduce((sum, key) => {
              return key.match(/感染症/) ? sum + absence[key] : sum;
            }, 0)
          };
        } else {
          // 欠席者がいないとき
          school["absence"] = {
            total: 0
          };
          school["pointsMap"] = {
            absencePointsMap: 0,
            infection: 0
          };
        }
        return school;
      });
    };
    expose({
      allSchoolList,
      isAuthenticated,
      optimizeBarChartRace,
      mergeSchoolAbsence
    });
    return {
      __sfc: true,
      isAuthenticated,
      me,
      allSchoolList,
      optimizeBarChartRace,
      mergeSchoolAbsence,
      TableRow,
      PieChart,
      Bar,
      PointsMap,
      BarChartRace,
      Inc137
    };
  }
});